import { render, staticRenderFns } from "./sign-up.html?vue&type=template&id=6af96928&scoped=true&external"
import script from "./sign-up.js?vue&type=script&lang=js&external"
export * from "./sign-up.js?vue&type=script&lang=js&external"
import style0 from "./sign-up.scss?vue&type=style&index=0&id=6af96928&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af96928",
  null
  
)

export default component.exports